<template>
  <div mg-stat-show="flag=610" mg-stat-lob="smod=banner">
    <swiper :options="swiperOption" ref="mySwiper" class="slide-wrapper">
      <swiper-slide v-for="(item, index) in list" :key="index">
        <div
          class="slide-item"
          :style="{ backgroundImage: 'url(' + item.img + ')' }"
          @click="clickBanner(item)"
        ></div>
      </swiper-slide>
      <div
        class="swiper-pagination"
        slot="pagination"
        :style="{ display: list.length > 1 ? 'flex' : 'none' }"
      ></div>
    </swiper>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { mapState } from 'vuex'
import { jumpPage, toParam } from '@/utils/mUtil'
import { loginMixin } from '@/utils/mixin'

export default {
  name: 'Slide',
  mixins: [loginMixin],
  props: {
    list: {
      type: Array,
      default: null,
    },

    carousel: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      swiperOption: {
        // autoplay: true,
        // loop: true,
        pagination: {
          el: '.swiper-pagination',
          renderBullet(index, className) {
            return `<span class="${className} swiper-pagination-bullet-custom"></span>`
          },
        },
      },
    }
  },
  created() {
    this.swiperOption.direction = 'horizontal'
    if (this.carousel) {
      this.swiperOption.autoplay = {
        delay: 5000,
        disableOnInteraction: false,
      }
    }
  },
  methods: {
    clickBanner(item) {
      MgStat.send(
        'click',
        {},
        {
          cntp: 'score_newHome',
          mod: 'banner',
          cont: '点击banner模块',
        }
      );

      let jumpUrl = item.landing

      if (jumpUrl.indexOf('imgotv://') > -1) {
        location.href = jumpUrl
      } else {
        jumpPage(jumpUrl)
      }
    },
  },
  components: {
    swiper,
    swiperSlide,
  },
  computed: {
    ...mapState(['userInfo']),
    swiper() {
      return this.$refs.mySwiper.swiper
    },
  },
}
</script>

<style lang="less" scoped>
.slide-item {
  width: 100%;
  height: 126px;
  border-radius: 36px;
  background-size: 100% 100%;
}

.slide-wrapper {
  margin: 0;
  width: 100%;
  
  .swiper-container {
    width: 100%;
  }

  .swiper-slide {
    width: 100%;
  }

  .swiper-pagination {
    position: absolute;
    bottom: 16px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2;

    .swiper-pagination-bullet {
      width: 6px;
      height: 6px;
      margin: 0 4px;
      background: rgba(255, 255, 255, 0.4);
      opacity: 1;

      &.swiper-pagination-bullet-active {
        background: #FFFFFF;
      }
    }
  }
}
</style>
